export default __webpack_public_path__ + "static/media/bamazon.6f8245ed.jpg";